import { Dispatch, AnyAction } from 'redux';

export const analytics = (handler: Function) => () => (next: Dispatch) => (
  action: AnyAction & {
    analytics?: {
      type: string;
      data: {};
      isDecision: boolean;
    };
  },
) => {
  if (!action.analytics || !action.analytics.type) return next(action);
  handler(
    action.analytics.type,
    action.analytics.data,
    action.analytics.isDecision,
  );
  return next(action);
};
